var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenceTypeCheckin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6529_9568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.38625V7.99958C14.6658 9.4372 14.2003 10.836 13.3395 11.9875C12.4787 13.1389 11.2688 13.9812 9.89016 14.3889C8.51154 14.7965 7.03809 14.7475 5.68957 14.2493C4.34104 13.7511 3.18969 12.8303 2.40723 11.6243C1.62476 10.4183 1.25311 8.99163 1.3477 7.55713C1.44229 6.12263 1.99806 4.75713 2.93211 3.6643C3.86615 2.57146 5.12844 1.80984 6.53071 1.49301C7.93298 1.17619 9.4001 1.32114 10.7133 1.90625M14.6666 2.66625L7.99992 9.33958L5.99992 7.33958",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6529_9568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceTypeCheckin);
export default __webpack_public_path__ + "static/media/licence_type_checkin.c1626f71ba5ac92d02c157cb80b2cfc4.svg";
export { ForwardRef as ReactComponent };